/**
 * @format
 * @module lib/commercial/keytar/subscriber
 */
import template from "./template";
import Wall from "lib/commercial/keytar/Wall";
import { WALL_TYPES } from "lib/commercial/keytar/WallAnalyticsSchema";
import { isFreeToViewReferrer } from "lib/commercial/keytar/helpers";
import isNil from "lodash/isNil";
import logger from "utils/logger";
import { processObjectMethods } from "../helpers";
import { isYellowCoronaArticle } from "utils/story";

const name = "subscriberPaywall";
const debugTag = `[KEYTAR] ${name}`;

const rules = [
  {
    /** @returns {Boolean} true when access is allowed for user */
    accessAllowed({ customer, gam }) {
      if (isNil(customer)) {
        return false;
      }
      const allowed = {
        isFreeToView: () => isFreeToViewReferrer(),
        isSub: () => customer.canAccessSubscriberContent,
        isSpecialAccess: () => {
          return customer.canAccessRegisteredContent && isYellowCoronaArticle(gam);
        }
      };
      const access = processObjectMethods(allowed);
      logger.info(`${debugTag} access:`, access, allowed);
      return access;
    },
    /** @returns {Boolean} true when wall should be used for article page */
    matcher({ paywallStatus }) {
      return ["red"].includes(paywallStatus);
    },
    /** @type {String} */
    name: name // red article story pages
  }
];

const props = {
  rules,
  featureFlagName: `${name}Enabled`, // defined in environment-variables.jsp
  template
};

export default new Wall("redwall", WALL_TYPES.PAYWALL_HARD, props);
